import { InjectionToken } from "@angular/core";
import { environment } from './../environments/environment';

export let APP_CONFIG = new InjectionToken<IAppConfig>('app.config');

export interface IAppConfig {
    endpointGetHtml: string;
    endpointMetadata: string;
    endpointLayers: string;
    endpointGrowApp: string;
}

export const APP_DI_CONFIG: IAppConfig = {
    endpointGetHtml: environment.endpointGetHtml,
    endpointMetadata: environment.endpointMetadata,
    endpointLayers: environment.endpointLayers,
    endpointGrowApp: environment.apiEndPointGrowApp
}
